module.exports = __webpack_public_path__ + "img/search-icon.e3aecf60.svg";